var _path, _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTournamentsHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 429,
    height: 87,
    viewBox: "0 0 429 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -80,
    y: -61.4023,
    width: 589,
    height: 227.5
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(40px)",
      clipPath: "url(#bgblur_0_4127_1924_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 80,
    d: "M213.581 19.6807C213.568 20.1803 213.567 20.1807 213.566 20.1807H213.564C213.562 20.1806 213.558 20.1798 213.554 20.1797C213.545 20.1794 213.531 20.1792 213.514 20.1787C213.478 20.1778 213.424 20.1767 213.353 20.1748C213.21 20.1711 212.999 20.1653 212.724 20.1582C212.172 20.1441 211.362 20.124 210.328 20.0986C208.259 20.0479 205.293 19.9775 201.704 19.8994C194.526 19.7433 184.855 19.5556 174.884 19.4307C164.912 19.3057 154.643 19.2433 146.269 19.3369C142.081 19.3837 138.371 19.4702 135.409 19.6064C132.435 19.7433 130.251 19.9293 129.095 20.1699C124.391 21.1487 120.582 23.7126 116.401 26.1113C112.244 28.4968 107.775 30.6758 101.888 30.6758H14.998C6.99002 30.6758 0.5 37.1676 0.5 45.1758V85.5977H428.5V45.1758C428.5 37.1665 422.033 30.6758 414.026 30.6758H325.354C319.573 30.6758 315.95 28.5961 312.402 26.2588C308.863 23.9267 305.424 21.3636 299.903 20.1689C297.149 19.5729 290.397 19.2668 281.748 19.1523C273.125 19.0382 262.678 19.1144 252.58 19.2666C242.483 19.4188 232.737 19.6476 225.516 19.8379C221.905 19.933 218.925 20.0182 216.848 20.0801C215.809 20.111 214.996 20.1361 214.443 20.1533C214.167 20.1619 213.955 20.1683 213.812 20.1729C213.741 20.1751 213.687 20.1776 213.651 20.1787C213.633 20.1793 213.619 20.1794 213.61 20.1797C213.606 20.1798 213.603 20.1796 213.601 20.1797C213.599 20.1797 213.598 20.1806 213.598 20.1807C213.597 20.1804 213.597 20.1673 213.581 19.6807ZM213.581 19.6807L213.597 20.1807H213.567L213.581 19.6807Z",
    fill: "url(#paint0_linear_4127_1924)",
    stroke: "url(#paint1_linear_4127_1924)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4127_1924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.222 25.799C125.612 21.9883 133.806 20 142.121 20L288.152 20.0001C295.975 20.0001 303.668 21.996 310.504 25.7991C317.339 29.6021 325.032 31.5981 332.855 31.5981H394.438H31.2695H94.3222C102.637 31.5981 110.831 29.6098 118.222 25.799Z",
    fill: "#00FF84",
    fillOpacity: 0.3
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 157.995,
    y: 18.5977,
    width: 114.107,
    height: 2,
    rx: 1,
    fill: "#00FF84"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_4127_1924_clip_path",
    transform: "translate(80 61.4023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.581 19.6807C213.568 20.1803 213.567 20.1807 213.566 20.1807H213.564C213.562 20.1806 213.558 20.1798 213.554 20.1797C213.545 20.1794 213.531 20.1792 213.514 20.1787C213.478 20.1778 213.424 20.1767 213.353 20.1748C213.21 20.1711 212.999 20.1653 212.724 20.1582C212.172 20.1441 211.362 20.124 210.328 20.0986C208.259 20.0479 205.293 19.9775 201.704 19.8994C194.526 19.7433 184.855 19.5556 174.884 19.4307C164.912 19.3057 154.643 19.2433 146.269 19.3369C142.081 19.3837 138.371 19.4702 135.409 19.6064C132.435 19.7433 130.251 19.9293 129.095 20.1699C124.391 21.1487 120.582 23.7126 116.401 26.1113C112.244 28.4968 107.775 30.6758 101.888 30.6758H14.998C6.99002 30.6758 0.5 37.1676 0.5 45.1758V85.5977H428.5V45.1758C428.5 37.1665 422.033 30.6758 414.026 30.6758H325.354C319.573 30.6758 315.95 28.5961 312.402 26.2588C308.863 23.9267 305.424 21.3636 299.903 20.1689C297.149 19.5729 290.397 19.2668 281.748 19.1523C273.125 19.0382 262.678 19.1144 252.58 19.2666C242.483 19.4188 232.737 19.6476 225.516 19.8379C221.905 19.933 218.925 20.0182 216.848 20.0801C215.809 20.111 214.996 20.1361 214.443 20.1533C214.167 20.1619 213.955 20.1683 213.812 20.1729C213.741 20.1751 213.687 20.1776 213.651 20.1787C213.633 20.1793 213.619 20.1794 213.61 20.1797C213.606 20.1798 213.603 20.1796 213.601 20.1797C213.599 20.1797 213.598 20.1806 213.598 20.1807C213.597 20.1804 213.597 20.1673 213.581 19.6807ZM213.581 19.6807L213.597 20.1807H213.567L213.581 19.6807Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4127_1924",
    x: 11.2695,
    y: 0,
    width: 403.169,
    height: 51.5977,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_4127_1924"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4127_1924",
    x1: 220,
    y1: 18.5977,
    x2: 220,
    y2: 203.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#342B2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593375,
    stopColor: "#171516"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4127_1924",
    x1: 220,
    y1: 18.5977,
    x2: 220,
    y2: 203.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8178,
    stopColor: "#474747",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTournamentsHeader);
export default __webpack_public_path__ + "static/media/tournamentsHeader.047139da2fdf5ef2a6f2ef654b3fd526.svg";
export { ForwardRef as ReactComponent };